import {
  DepositSlipsGetters,
  DepositSlipsMutations,
  DepositSlipsActions
} from '@/app/features/deposit-slips/deposit-slips.keys';
import { depositSlipsService } from '@/app/features/deposit-slips/deposit-slips.service';

export const getInitialState = () => {
  return {
    depositSlips: [],
    depositSlipsIsLoading: false,
    depositSlipsListingPagination: {
      offset: 0,
      recordsPerPage: 10
    },
    depositSlipsRecordCount: 0,
    depositSlipDownloadComplete: false
  };
};

export const depositSlipsStore = {
  state: getInitialState(),
  getters: {
    [DepositSlipsGetters.DepositSlips]: state => {
      return state.depositSlips;
    },
    [DepositSlipsGetters.DepositSlipsPerPage]: state => {
      return state.depositSlipsListingPagination.recordsPerPage;
    },
    [DepositSlipsGetters.DepositSlipsOffset]: state => {
      return state.depositSlipsListingPagination.offset;
    },
    [DepositSlipsGetters.DepositSlipsLoading]: state => {
      return state.depositSlipsIsLoading;
    },
    [DepositSlipsGetters.DepositSlipsRecordCount]: state => {
      return state.depositSlipsRecordCount;
    }
  },
  mutations: {
    [DepositSlipsMutations.RetrieveDepositSlips]: (state, slips) => {
      state.depositSlips = slips;
    },
    [DepositSlipsMutations.UpdateDepositSlipsPagination]: (state, params) => {
      state.depositSlipsListingPagination.recordsPerPage = params.recordsPerPage;
      state.depositSlipsListingPagination.offset = params.offset;
    },
    [DepositSlipsMutations.SetDepositSlipsLoading]: (state, isLoading = true) => {
      state.depositSlipsIsLoading = isLoading;
    },
    [DepositSlipsMutations.SetDepositSlipsRecordCount]: (state, count) => {
      state.depositSlipsRecordCount = count;
    },
    [DepositSlipsMutations.SetDepositSlipDownloadComplete]: (state, downloadComplete = true) => {
      state.depositSlipDownloadComplete = downloadComplete;
    }
  },
  actions: {
    [DepositSlipsActions.RetrieveDepositSlips]: ({ state, commit }) => {
      commit(DepositSlipsMutations.SetDepositSlipsLoading);
      return depositSlipsService
        .getDepositSlips(state.depositSlipsListingPagination)
        .then(res => {
          commit(DepositSlipsMutations.RetrieveDepositSlips, res.slips);
          commit(DepositSlipsMutations.SetDepositSlipsRecordCount, res.count);
        })
        .then(() => {
          commit(DepositSlipsMutations.SetDepositSlipsLoading, false);
        });
    },
    [DepositSlipsActions.SetDepositSlipsPagination]: ({ commit, dispatch }, pagination) => {
      commit(DepositSlipsMutations.UpdateDepositSlipsPagination, pagination);
      dispatch(DepositSlipsActions.RetrieveDepositSlips);
    },
    [DepositSlipsActions.DownloadDepositSlip]: ({ commit }, payload) => {
      return depositSlipsService
        .downloadDepositSlip(payload.attachment_id, payload.original_name)
        .then(response => {
          if (response.data.size > 0) {
            commit(DepositSlipsMutations.SetDepositSlipDownloadComplete);
          } else {
            commit(DepositSlipsMutations.SetDepositSlipDownloadComplete, false);
          }
        });
    }
  }
};
